<template>
    <div :class="`input_wrapper ${errorMessage ? 'failed' : ''}`">
        <input 
          :type="type"
          v-model="value"
          @input="$emit('update:value', value)"
          ref="input"
        >
        <label :class="value ? 'active' : ''" @click="$refs.input.focus()">{{placeholder}}</label>
        <div class="error-label">{{ errorMessage }}</div>
    </div>
</template>

<script>
export default {
    name: "Input",
    props: {
        placeholder: {
          type: String,
          default: ""
        },
        type: {
          type: String,
          default: "text"
        },
        errorMessage: {
          type: String,
          default: ''
        }
    },
    emits: ["update:value"],
    data () {
        return {
            value: ""
        }
    },
}
</script>

<style>
  .input_wrapper {
    .error-label {
      display: none;
    }

    &.failed {
      input {
        border: 1px solid red;
      }
      .error-label {
        display: block;
        margin-top: 4px;
        color: red;
        font-size: 12px;
      }
    }
  }
</style>